import api from '@/api';

const resource = 'atena/perfil';

export default {
  getPerfis() {
    return api.get(`${resource}`);
  },
  getPerfil(id) {
    return api.get(`${resource}/${id}`);
  },
  postPerfil(data) {
    return api.post(`${resource}`, data);
  },
  putPerfil(data) {
    return api.put(`${resource}/${data.identificadorperfil}`, data);
  },
  deletePerfil(id) {
    return api.delete(`${resource}/${id}`);
  },
  getSelectPerfil() {
    return api.get(`${resource}/select`);
  },
  getPerfisModuloMerenda() {
    return api.get(`${resource}/modulo-merenda`);
  }
};
